module.exports = __webpack_public_path__ + "static/media/The_Great_Divide_Coep.c58b782e.pdf";